import isEmptyObject from './is-empty-object';

/** To retrieve error message as part of enrollCard response.
 * Handle non standard error message coming as part of BE response
 * @param {object} responseData
 * @returns {string}
 */
const getErrorMessageFromResponse = responseData => {
  if (!isEmptyObject(responseData)) {
    const { errorCode, reason } = responseData;
    if (errorCode === 'ISSUER_OFFERED_CARD_ADD_FAILED') {
      return null;
    }
    return reason ? reason : errorCode;
  }
  return null;
};

export default getErrorMessageFromResponse;
